<template>
  <QPaginatedSearchDropdown :key="resetKey" :value="value" :list-getter="getCustomerGroupListFromFilter"
    :filter="filter" :min-search-char-limit="0" :externaledit="externaledit" :clearable="clearable" :multiple="multiple"
    :returnobject="returnobject" :disabled="disabled" :loading="createLoading || loading" valuekey="Id" textkey="Name"
    :label="label ? label : $t('servicesystem.common_objects.customer_group.customer_group')"
    :placeholder="placeholder ? placeholder : $t('servicesystem.common_objects.customer_group.search_field_label')"
    :rules="rules" @input="e => $emit('input', e)" @change="e => $emit('change', e)"
    @FocusState="e => $emit('FocusState', e)"> <!-- :allow-create="allowCreate" @create="e => createNew(e)" -->
    <template v-if="!hideIcon" v-slot:prepend-outer>
      <v-icon size="20">$customer_group</v-icon>
    </template>
    <template v-slot:append-outer>
      <slot name="append-outer" />
    </template>
  </QPaginatedSearchDropdown>
</template>


<script>
import clientAPI from "@/api/ClientAPIMixin.js";
import QPaginatedSearchDropdown from "@/components/Inputs/QPaginatedSearchDropdown.vue";
import rules from "@/helpers/Mixins/QInputRuleMixin.js";

export default {
  name: "SupplierSelect2",
  model: {
    prop: "value",
    event: "input",
  },
  props: {
    label: String,
    placeholder: String,
    value: [Object, String, Number, Array],
    clearable: Boolean,
    disabled: Boolean,
    loading: Boolean,
    externaledit: Boolean,
    filter: Object,
    returnobject: Boolean,
    multiple: Boolean,
    rules: Array,
    //allowCreate: Boolean,
    hideIcon: Boolean,
  },
  components: {
    QPaginatedSearchDropdown,
  },
  mixins: [clientAPI, rules],

  data() {
    return {
      createLoading: false,
      resetKey: 1,
    };
  },

  methods: {},

  computed: {},

  watch: {},
};
</script>


<style lang="scss"></style>